import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { ClassType } from './class-type.model';
import { ClassTypePopupService } from './class-type-popup.service';
import { ClassTypeService } from './class-type.service';
import { School, SchoolService } from '../school';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { Principal, CRUD_ACTIONS } from '../../shared/index';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-class-type-dialog',
    templateUrl: './class-type-dialog.component.html'
})
export class ClassTypeDialogComponent extends AbstractDialogComponent implements OnInit {

    classType: ClassType;
    authorities: any[];
    isSaving: boolean;
    backgroundColor: string;

    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        alertService: AlertService,
        private classTypeService: ClassTypeService,
        schoolService: SchoolService,
        private eventManager: EventManager,
        principal: Principal
    ) {
        super(schoolService, alertService, principal);
        this.jhiLanguageService.setLocations(['classType']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'];
        this.backgroundColor = '#' + this.classType.backgroundColor;
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        this.classType.backgroundColor = this.backgroundColor.slice(1);
        if (this.classType.id !== undefined) {
            this.classTypeService.update(this.classType)
                .delay(8000)
                .subscribe((res: ClassType) =>
                    this.onSaveSuccess(res, CRUD_ACTIONS.UPDATE), (res: HttpErrorResponse) => this.onSaveError(res));
        } else {
            this.classTypeService.create(this.classType)
                .subscribe((res: ClassType) =>
                    this.onSaveSuccess(res, CRUD_ACTIONS.CREATE), (res: HttpErrorResponse) => this.onSaveError(res));
        }
    }

    showLoader(): boolean {
        return this.isSaving && this.classType.id !== undefined;
    }

    private onSaveSuccess(result: ClassType, action: String) {
        this.eventManager.broadcast({ name: 'classTypeListModification', content: {
            action: action,
            content: result
        }});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    trackSchoolById(index: number, item: School) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-class-type-popup',
    template: ''
})
export class ClassTypePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private classTypePopupService: ClassTypePopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.modalRef = this.classTypePopupService
                    .open(ClassTypeDialogComponent as Component, params['id']);
            } else {
                this.modalRef = this.classTypePopupService
                    .open(ClassTypeDialogComponent as Component);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/class-type/class-type-dialog.component.ts